function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import get from 'lodash/get';
var _React_Component;
/**
 * CompoundInput is a component to wrap different inputs, selects etc in one data structure inside FormGroup.
 *
 * @param {string} id - unique id of the inputs group
 * @param {string} children - form inputs components. These components must have explicitly defined unique id.
 *        In addition, beside normal properties, every component inside CompoundInput may have `containerClasses`
 *        property, which defines classes for special wrapper of that input.
 * @param {string} [value=""] - currently set values
 * @param {function} onChange - action that is triggered by value change
 */ class CompoundInput extends (_React_Component = React.Component) {
    onChange(input) {
        const value = _object_spread_props(_object_spread({}, this.props.value), {
            [input.id]: input.value
        });
        return this.props.onChange({
            id: this.props.id,
            value
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: "row",
            children: this.props.children.map((child)=>/*#__PURE__*/ _jsx("div", {
                    className: cn(child.props.containerClassName),
                    children: /*#__PURE__*/ React.cloneElement(child, {
                        id: child.props.id,
                        value: get(this.props.value, child.props.id),
                        onChange: (input)=>this.onChange(input),
                        hasError: this.props.hasError
                    })
                }, child.props.id))
        });
    }
}
_define_property(CompoundInput, "propTypes", {
    id: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element)
    ]).isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    onChange: PropTypes.func.isRequired,
    hasError: PropTypes.bool
});
_define_property(CompoundInput, "defaultProps", {
    value: {}
});
export default CompoundInput;
